'use strict';
const store = require('store');

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var StoreController = function () {

    /**
     * Gets the platformId and userSub in order to prefix the local storage keys 
     * for the values to be platform and user independent
     * @param {string}   [platformId]   Platform identifier
     * @param {string}   [userSub]      User identifier
     */
    function StoreController(platformId, userSub) {
        _classCallCheck(this, StoreController);

        this.platformId = platformId;
        this.userSub = userSub;

        //BINDINGS
        this.get = this.get.bind(this);
        this.set = this.set.bind(this);
        this.composeKey = this.composeKey.bind(this);
    }

    /**
     * Gets a key and returns the value for that key
     * @param {string}  [key]    Local storage "variable" identifier
     * @return {Object}          nullable
     */


    _createClass(StoreController, [{
        key: 'get',
        value: function get(key) {
            return store.get(this.composeKey(key));
        }

        /**
         * Sets a new value for the provided key to the local storage
         * @param {string}   [key]      Local storage "variable" identifier
         * @param {Object}   [value]    new or updated value for the current key
         * @return {Object}             the value updated to the store
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            return store.set(this.composeKey(key), value);
        }

        /**
         * Gets a local storage key and returns the combination of platformId, userSub and the key
         * in order to make it only avaliable for the current platform and the current user.
         * @param {string}  [key]    Local storage "variable" identifier
         * @return {string}
         */

    }, {
        key: 'composeKey',
        value: function composeKey(key) {
            return this.platformId + '|' + this.userSub + '|' + key;
        }
    }]);

    return StoreController;
}();

module.exports = StoreController;